import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { fetchCategoriesAsync } from '../../admin/questions/CategoriesView/categorySlice';
import { Box, Button, Container, Typography } from '@mui/material';
import CategoryDrawer from './CategoryDrawer';
import { useNavigate, useParams } from 'react-router-dom';
import {
  clearQuestions,
  fetchQuestionsAsync,
  selectQuestions
} from '../../admin/questions/QuestionsView/questionSlice';
import QuestionCard from './QuestionCard';
import { Question } from '../../../generated/api';
import { selectAttempts } from './attemptSlice';
import { fetchAnswersAsync } from './answerSlice';
import { DialogState } from '../../../app/types';
import { setDialog } from '../../../app/appSlice';

const TestView = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const questionState = useAppSelector(selectQuestions);
  const attemptState = useAppSelector(selectAttempts);
  const { categoryId, questionIndex } = useParams();
  const [question, setQuestion] = useState<Question | null>(null);
  const [unsavedChanges, setUnsavedChanges] = useState<boolean>(false);

  useEffect(() => {
    dispatch(fetchCategoriesAsync());
    dispatch(fetchAnswersAsync());
  }, []);

  useEffect(() => {
    if (!categoryId || isNaN(parseInt(categoryId))) return;
    dispatch(clearQuestions());
    dispatch(fetchQuestionsAsync(parseInt(categoryId)))
      .unwrap()
      .then((value) => {
        if (!value.length || questionIndex) return;
        navigate(`/test/${categoryId}/0`);
      });
  }, [categoryId]);

  useEffect(() => {
    if (questionIndex && !isNaN(parseInt(questionIndex)) && questionState.questions) {
      setQuestion(questionState.questions[parseInt(questionIndex)]);
    } else {
      setQuestion(null);
    }
  }, [questionIndex, questionState.questions]);

  useEffect(() => {
    window.onbeforeunload = unsavedChanges ? () => true : null;
  }, [unsavedChanges]);

  const handleNavigate = (to: string) => {
    if (unsavedChanges) {
      const dialog: DialogState = {
        open: true,
        title: 'You have unsaved changes!',
        description: 'Do you want to discard these changes?',
        onOk: () => {
          navigate(to);
          setUnsavedChanges(false);
        }
      };
      dispatch(setDialog(dialog));
    } else {
      navigate(to);
    }
  };

  const nextQuestion = () => {
    if (!questionIndex) return;
    handleNavigate(`/test/${categoryId}/${parseInt(questionIndex) + 1}`);
  };
  const prevQuestion = () => {
    if (!questionIndex) return;
    handleNavigate(`/test/${categoryId}/${parseInt(questionIndex) - 1}`);
  };

  const nextDisabled = !questionIndex || parseInt(questionIndex) >= questionState.questions.length - 1;

  const prevDisabled = !questionIndex || parseInt(questionIndex) <= 0;

  if (!attemptState.attempt) return null;

  return (
    <Box display="flex" flexDirection="row">
      <CategoryDrawer navigate={handleNavigate} />
      {question && (
        <Container maxWidth="lg">
          <Box display="flex" justifyContent="space-between" marginY={1}>
            <Button onClick={prevQuestion} disabled={prevDisabled} variant="outlined">
              Prev
            </Button>
            {questionIndex && (
              <Typography margin="auto">
                {parseInt(questionIndex) + 1} / {questionState.questions.length}
              </Typography>
            )}
            <Button onClick={nextQuestion} disabled={nextDisabled} variant="outlined">
              Next
            </Button>
          </Box>
          <QuestionCard question={question} setUnsavedChanges={setUnsavedChanges} />
        </Container>
      )}
    </Box>
  );
};

export default TestView;
